<template>
    <div>

        <div>

            <el-button type="success" title="添加图片" class="el-icon-picture-outline file">
                <input class="input_file" type="file" @change="uploadImg($event, 1)">
            </el-button>

            <el-button type="success" title="放大" class="el-icon-zoom-in" @click="changeScale(1)"></el-button>
            <el-button type="success" title="缩小" class="el-icon-zoom-out" @click="changeScale(-1)"></el-button>
            <el-button type="success" title="向左转" class="el-icon-refresh-left" @click="rotateLeft"></el-button>
            <el-button type="success" title="向右转" class="el-icon-refresh-right" @click="rotateRight"></el-button>
            <el-button type="success" title="上传" class="el-icon-upload2" @click="finish('blob')"></el-button>

        </div>

        <div class="line">
            <div class="cropper-content">
                <div class="cropper">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :fixedBox="option.fixedBox"
                        @realTime="realTime"
                    ></vue-cropper>
                </div>

                <div :style="previews.div" class="preview">
                    <img :src="previews.url" :style="previews.img">
                </div>
            </div>
        </div>

        <el-button type="primary" @click="Submit">确定</el-button>
    </div>
</template>

<script>
    import services from "../cicd.services";

    export default {

        props: {
            type: {
                type: String,
                default: "use"
            },

            id: Number | String,

            callback: Function
        },

        data() {
            return {
                previews: {},
                option: {
                    img: "",
                    outputSize:1, //剪切后的图片质量（0.1-1）
                    full: false,//输出原图比例截图 props名full
                    outputType: "png",
                    canMove: true,
                    original: false,
                    canMoveBox: true,
                    autoCrop: true,
                    autoCropWidth: 150,
                    autoCropHeight: 150,
                    fixedBox: false
                },
                fileName:"banner.png",  //本机文件地址
                uploadImgRelaPath:"", //上传后的图片的地址（不带服务器域名）
                imgUrl: ""
            }
        },

        created() {
            let params = this.setPatams();
            services.imgList(params)
                .then(res => {
                    this.option.img = res.url;
                    this.fileName = res.title;
                })
                .catch(err => this.$message.error(err.message))
        },
        methods: {

            setPatams() {
                return {
                    appId: this.id,
                    folder_or_app: this.type
                };
            },

            //放大/缩小
            changeScale(num) {
                num = num || 1;
                this.$refs.cropper.changeScale(num);
            },

            //坐旋转
            rotateLeft() {
                this.$refs.cropper.rotateLeft();
            },

            //右旋转
            rotateRight() {
                this.$refs.cropper.rotateRight();
            },

            //上传图片（点击上传按钮）
            finish(type) {
                let _this = this;
                // 输出 
                if (type === "blob") {
                    this.$refs.cropper.getCropBlob((data) => {
                        let img = window.URL.createObjectURL(data);
                        this.model = true;
                        this.modelSrc = img;
                        let file = new File([data], this.fileName + ".png", {type: data.type, lastModified: Date.now()});
                        services.upload({file_name: file})
                            .then(res => {
                                _this.imgUrl = res.download_url;
                                _this.$message.success("上传成功");
                            })
                            .catch(err => _this.$message.error(err.message))
                    })
                } else {
                    this.$refs.cropper.getCropData((data) => {
                        this.model = true;
                        this.modelSrc = data;
                    })
                }
            },

            // 实时预览函数 
            realTime(data) {
                this.previews = data;
            },

            //选择本地图片
            uploadImg(e, num) {
                let _this = this;
                //上传图片 
                let file = e.target.files[0];
                _this.fileName = file.name;
                // console.log(e.target,'e.target');
                // console.log(e.target.value,'e.target.value');
                // console.log(/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value));
                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                    this.$message.info("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
                    return false;
                }
                let reader = new FileReader();
                reader.onload =(e) => {
                    let data;
                    if (typeof e.target.result === "object") {
                        // 把Array Buffer转化为blob 如果是base64不需要
                        data = window.URL.createObjectURL(new Blob([e.target.result]));
                    }
                    else {
                        data = e.target.result;
                    }
                    if (num === 1) {
                        let blob = new Blob([e.target.result]);
                        _this.option.img = data;
                        services.upload({file_name: file})
                            .then(res => _this.imgUrl = res.download_url)
                            .catch(err => _this.$message.error(err.message))
                    } else if (num === 2) {
                        _this.example2.img = data;
                    }
                }
                reader.readAsArrayBuffer(file);
            },

            // 点击确定提交
            Submit() {
                this.$modal.close();
                this.callback(this.imgUrl ? this.imgUrl : this.option.img);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .cropper-content {
        padding: 20px 0;
        display:flex;
        .cropper {
            width: 260px;
            height: 260px;
        }
        .preview {
            overflow: hidden;
            border:1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
        }
    }
    .file {
        position: relative;
        input {
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0;
        }
    }
</style>
